<template>
    <form-group
            :name="name"
            :label="label"
            :help-text="helpText"
            :error="error"
            :label-width="labelWidth"
            :input-width="inputWidth"
    >
        <table-widget
                :name="name"
                :value="value"
                :options="options"
                :error="error"
                :disabled="disabled"
                :option-label="optionLabel"
                @input="$emit('input', $event)"
        ></table-widget>
    </form-group>
</template>

<script>
    import TableWidget from "@/components/FormGroups/Widgets/Table"
    import FormGroup from "@/vendor/forms/FormGroups/Horizontal/FormGroup"

    export default {
        components: {TableWidget, FormGroup},

        props: {
            "name": {},
            "label": {},
            "helpText": {"default": null},
            "value": {},
            "error": {},
            "labelWidth": {},
            "inputWidth": {},
            "options": {},
            "disabled": {"default": false},
            optionLabel: {}
        }
    }
</script>
